export type OrgRole = 'admin' | 'fin_ops' | 'employee' | null;

/** Role-aware landing: resolved by `/inicio` once the org role is known. */
export const HOME_ROUTE = '/inicio';

/** Future creator host. Same build; session is per origin. */
export function isCreatorsHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'criadores.seu.video' || host === 'www.criadores.seu.video';
}

export function homePathForRole(role: OrgRole): string {
  if (isCreatorsHost()) return '/estudio';
  return role && role !== 'admin' ? '/explorar' : '/app';
}
